import Icon from '../components/Icon.vue'

Icon.register({
  cog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M487.4 315.7c4.9 2.8 7.1 8.6 5.6 14.1-11.1 35.7-30 67.9-54.7 94.6-3.8 4.2-9.9 5.1-14.8 2.3l-42.6-24.6c-18 15.3-38.6 27.2-60.8 35.1v49.2c0 5.6-3.9 10.5-9.4 11.7-34.9 7.8-72.5 8.2-109.2 0-5.5-1.2-9.4-6.1-9.4-11.7v-49.2c-22.3-7.8-42.9-19.7-60.8-35.1l-42.6 24.6c-4.8 2.8-11 1.8-14.8-2.3-24.7-26.8-43.6-59-54.7-94.6-1.6-5.4 0.6-11.2 5.5-14l42.6-24.6c-4.3-23.2-4.3-47 0-70.2l-42.6-24.6c-4.9-2.8-7.2-8.6-5.5-14 11.1-35.7 30-67.9 54.7-94.6 3.8-4.2 9.9-5.1 14.8-2.3l42.5 24.6c18-15.3 38.6-27.2 60.8-35.1v-49.2c0-5.6 3.9-10.5 9.4-11.7 34.9-7.8 72.5-8.2 109.2 0 5.5 1.2 9.4 6.1 9.4 11.7v49.1c22.3 7.8 42.9 19.7 60.8 35.1l42.6-24.6c4.8-2.8 11-1.8 14.8 2.3 24.7 26.8 43.6 59 54.7 94.6 1.6 5.4-0.6 11.2-5.5 14l-42.6 24.6c4.3 23.2 4.3 47 0 70.2zM256 336c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80z'
      }
    ]
  }
})
